import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter, HostListener,
  Input, OnChanges, OnDestroy,
  OnInit,
  Output,
  QueryList,
  SimpleChanges,
  TemplateRef,
  ViewChild,
  ViewChildren
} from '@angular/core';
import { FormControl, NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MatSelect } from '@angular/material';
import { MatAccordion, MatExpansionPanel } from '@angular/material/expansion';
import { MatSort } from '@angular/material/sort';
import { ActivatedRoute, Router } from '@angular/router';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, ReplaySubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DocumentCustomerEntity } from 'src/app/core/class/document-customer-entity';
import { DocumentEntity } from 'src/app/core/class/DocumentEntity';
import { EnterpriseEntity } from 'src/app/core/class/enterpriseEntity';
import { Message } from 'src/app/core/class/message';
import { UserEntity } from 'src/app/core/class/UserEntity';
import { EnumAdjustedContents } from 'src/app/core/constants/contract';
import { ErrorCode } from 'src/app/core/constants/error-code';
import { FeatureGroup } from 'src/app/core/constants/permission';
import { SCREEN_SIZE } from 'src/app/core/constants/screen-size';
import { AutoDocumentTypeParentFilterBynameService } from 'src/app/core/services/auto-document-type-parent-filter-byname.service';
import { AutoDocumentTypeParentService } from 'src/app/core/services/auto-document-type-parent.service';
import { AutoDocumentTypeService } from 'src/app/core/services/auto-document-type.service';
import { AutoEnterpriseService } from 'src/app/core/services/auto-enterprise.service';
import { CommonService } from 'src/app/core/services/common.service';
import { ContractService } from 'src/app/core/services/contract.service';
import { CreateContractMohaService } from 'src/app/core/services/create-contract-moha.service';
import { DocumentMohaService } from 'src/app/core/services/document-moha.service';
import { DocumentTypeService } from 'src/app/core/services/document-type.service';
import { DocumentService } from 'src/app/core/services/document.service';
import FileUtils, { ContentType } from 'src/app/core/services/file-utils';
import { WarningSmsContractService } from 'src/app/core/services/warning-sms-contract.service';
import { AutocompleteComponent } from 'src/app/shared/components/autocomplete/autocomplete.component';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { FileAttachMohaComponent } from 'src/app/shared/components/file-attach-moha/file-attach-moha.component';
import { ViewDocumentReferenceComponent } from 'src/app/shared/components/view-document-reference/view-document-reference.component';
import { DigitalContractService } from "../../../../../../../core/services/digital-contract.service";
import { AddDocumentGroupV3Component } from '../../add-document/general-form-info/add-document-group-v3/add-document-group-v3.component';
import { ViewContractComponent } from "../../contract-digitization/view-contract/view-contract.component";

// Jquery function for enabling radio and checkbox
declare function enableFormFields(): any;

// Jquery function for enabling input
declare function enableFormInput(): any;

@Component({
  selector: 'app-general-form-info-moha',
  templateUrl: './general-form-info-moha.component.html',
  styleUrls: ['./general-form-info-moha.component.scss']
})
export class GeneralFormInfoMohaComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy, OnChanges {

  @BlockUI() blockUI: NgBlockUI;
  current: any = 0;
  configAutoNumber: string;
  public mediaBreakpoint: any;
  public subscribeMediaBreakPointService: Subscription;
  public SCREEN_SIZE = SCREEN_SIZE;
  constructor(
    private el: ElementRef,
    public autoDocumentTypeData: AutoDocumentTypeService,
    private toastr: ToastrService,
    private documentService: DocumentService,
    private documentMohaService: DocumentMohaService,
    public commonService: CommonService,
    public message: Message,
    private digitalContractService: DigitalContractService,
    private modalService: NzModalService,
    private warningSmsContractService: WarningSmsContractService,
    public autoDocumentTypeParentData: AutoDocumentTypeParentService,
    public autoDocumentTypeParentFilterBynameData: AutoDocumentTypeParentFilterBynameService,
    public createContractMohaService: CreateContractMohaService,
    private documentTypeService: DocumentTypeService,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    public autoEnterpriseService: AutoEnterpriseService,
    private router: Router,
    private contractService: ContractService,
  ) {
    super(commonService, message);
    this.isShowReferencePdf = new BehaviorSubject<boolean>(false);
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.messageError = this.message.getMessage('validation.contract_file_config').replace('{0}', String(Math.floor(this.maxSize / 1024 / 1024)))
  }

  public cecaEnable: boolean;

  recordSelectedEnterprise: EnterpriseEntity;
  formChangesSubscription: Subscription;
  fileUpload: File;
  private subscribeSubmitData: Subscription;

  private pdfSrc: string;
  private dialogRefFileAttachMohaComponent: MatDialogRef<FileAttachMohaComponent, any>;
  public onChangeTemplate = new Subject();
  hideDocumentParent = false;

  private templateDocument: any;
  firstEditLoaded = true;
  isFormChanging = false;
  refreshContractCode = false;
  duplicatedUploadFileTitle: string;
  isOnAutoNumber = false;
  @Input() maxSize: number = 10485760;
  @Input() check: any;
  valueSelect: number;
  size1MB = 1*1024*1024;
  @ViewChild('f', { read: NgForm, static: true }) ngForm: NgForm;
  @ViewChildren(MatExpansionPanel) panels: QueryList<MatExpansionPanel>;
  // Refresh input file
  @ViewChild('inputUpload', { read: '', static: false }) inputUploadFile: ElementRef;

  @ViewChild('panelSubmit', { read: '', static: false }) btnSubmit: ElementRef;

  @ViewChild('documentSignPage', { read: '', static: false }) inputSignPage: ElementRef;

  @ViewChild('documentTypeSelect', { static: false }) documentTypeSelect: MatSelect;
  @ViewChild('serviceTypeSelect', { static: false }) serviceTypeSelect: MatSelect;
  @ViewChild('isConfirmBCTSelect', { static: false }) isConfirmBCTSelect: MatSelect;

  @ViewChildren('focusInput') focusInput;
  @ViewChildren('accordion') accordion: MatAccordion;

  @ViewChild('serviceTypeId', { static: false }) serviceTypeId: MatSelect;
  @ViewChild(AutocompleteComponent, { read: AutocompleteComponent, static: false }) autocompleteComponent;
  @ViewChild('autoComplete', { read: AutocompleteComponent, static: false }) autoComplete: AutocompleteComponent;
  @ViewChild('parentDocument', { read: AutocompleteComponent, static: false }) parentDocument: AutocompleteComponent;
  @ViewChild('enterpriseElementViewChild', {
    read: AutocompleteComponent,
    static: false
  }) enterpriseElementViewChild: AutocompleteComponent;
  @ViewChild('documentTypeAuto', {
    read: AutocompleteComponent,
    static: false
  }) documentTypeAuto: AutocompleteComponent;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild('performSelect', { static: false }) performSelect: MatSelect;
  @ViewChild('userElementViewChild', {
    read: AutocompleteComponent,
    static: false
  }) userElementViewChild: AutocompleteComponent;
  // Selected documentType
  selectedDocumentType: { id: string, name: '', parentId: null };
  validateSuccess = false;
  checkFocus = false;
  userInformation: UserEntity;
  document: DocumentEntity;
  timeOutQueryServer1 = null;
  parentContracts = [];
  nzCheckLoadingParty1 = false;
  listParentHeight = 0;
  parentActive = -1;
  defaultCustomerModel: DocumentCustomerEntity;
  customer: DocumentCustomerEntity;
  public isShowReferencePdf: BehaviorSubject<boolean>;
  parentDocumentMetaData = {
    phone: '',
    email: ''
  };
  selectedDocumentTypeParent: { id: string, name: string, code?: string, filePath?: string };
  serviceTypesFilterCtrl: FormControl = new FormControl();
  private onDestroy = new Subject<void>();
  serviceTypes: any[];
  cities: { id: number, name: '', description: '' }[];
  districts: { id: number, cityId: number, name: '', description: '' }[];
  wards: { id: number, districtId: number, name: '', description: '' }[];
  selectedDistricts: { id: number, cityId: number, name: '', description: '' }[];
  selectedWards: { id: number, districtId: number, name: '', description: '' }[];
  public filteredServiceTypes: ReplaySubject<comboBox[]> = new ReplaySubject<comboBox[]>(1);
  @Input() warningContractQuantity: boolean;
  dataDocumentParent: any[] = [];
  dataDocumentParentNewUploadContractAttachments: any[] = [];
  dataDocumentParent1 = [
    {
      "id": "NTA0ZHMkZCNzQSYqJioyMjE2NA==",
      "code": "SH-1",
      "name": "SH 1",
      "idDecrypt": 22164
    },
    {
      "id": "NTA0ZHMkZCNzQSYqJioyMjE2NQ==",
      "code": "SH-2",
      "name": "SH2",
      "idDecrypt": 22165
    },
    {
      "id": "NTA0ZHMkZCNzQSYqJioyMjE2OA==",
      "code": "SH-4",
      "name": "namDP",
      "idDecrypt": 22168
    },
    {
      "id": "NTA0ZHMkZCNzQSYqJioyMjE2OQ==",
      "code": "SH-3",
      "name": "SH3",
      "idDecrypt": 22169
    }
  ]
  contractView = {
    contractName: '',
    id: [],
    filesName: [],
    listFileSize: [],
    idDocument:'',
    checkMan:2,
    attachments:[]
  };
  inputInternalDocumentsValue:string;
  checkExpiredReq = true;
  tplModal: NzModalRef;
  minDate = new Date();
  // merge 21511
  // signPageControl = new FormControl({
  //   value: 1,
  //   disabled: this.warningContractQuantity
  // });
  // merge 21511
  duplicatedUploadFileNames = [];
  @Output() hasChange: EventEmitter<boolean> = new EventEmitter();
  attachments = [];
  isUpdate: boolean = false;
  flagCopy;
  subscriptions: Subscription = new Subscription();
  displayItem = (x: any) => x !== null ? x.id !== undefined ? x.code + ' - ' + x.name : '' : '';
  messageError: string = ''

  isNotAttestedUser: boolean = false;

  isShowAddDocument: boolean = false;
  permissions: any;
  messageTitle: string = '';

  effectiveDateErr: string = '';
  finishedDateErr: string = '';
  adjustedContents: any[] = [];
  adjustedContentSelected: any;
  public enumAdjustedContents = EnumAdjustedContents;
  @ViewChild('adjustedSelect', {static: false}) adjustedSelect: MatSelect;
  isPlContract: boolean = false;
  ngOnInit() {
    this.flagCopy = this.route.snapshot.queryParams.flagCopy;
    this.isUpdate = this.route.snapshot.queryParams && (this.route.snapshot.queryParams.typeUpdate || (this.route.snapshot.queryParams.goFrom == 'hdld' && !this.route.snapshot.queryParams.flagCopy && !this.route.snapshot.queryParams.termination));
    this.current = this.createContractMohaService.currentStep.getValue();
    this.permissions = JSON.parse(localStorage.getItem('permissions')) || '';
    if (this.permissions.includes(FeatureGroup.MANAGE_ENTERPRISE)) {
      this.isShowAddDocument= true;
    } else {
      this.isShowAddDocument= false;
    }

    if (this.createContractMohaService.isOnAutoNumber.getValue()) {
      this.isOnAutoNumber = this.createContractMohaService.isOnAutoNumber.getValue();
    }
    this.initData();

    this.subscribeValue();
    // Get infor Enterprise current
    // if (!this.document.id) {
    //   this.getDefaultEnterprises();
    // }
    this.getServiceTypes();
    this.getPropertiesForUpdate();

    // this.createContractMohaService.isConfirmBCT.next(this.document.isConfirmBCT);
    this.createContractMohaService.codeIsDuplicate.subscribe(rs => {
      if (rs) {
        this.documentCodeDuplicateHanlder(rs);
        this.createContractMohaService.codeIsDuplicate.next(false);
        this.createContractMohaService.isDuplicateCode.next(false);
      }

    })
    this.refreshContractCode = this.createContractMohaService.refreshContractCode.getValue();
    this.configAutoNumber = this.createContractMohaService.configAutoNumber.getValue();
  }

  subscribeValue() {
    // merge 21511
    // this.subscriptions.add(
    //   this.warningSmsContractService.statusUpdated.subscribe(
    //     (warningContractQuantity) => {
    //       this.warningContractQuantity = warningContractQuantity;
    //     }
    //   )
    // );
// merge 21511
    this.serviceTypesFilterCtrl.valueChanges
      .pipe(takeUntil(this.onDestroy))
      .subscribe(
        () => {
          this.commonService.filterCertificateType(this.serviceTypes, this.serviceTypesFilterCtrl, this.filteredServiceTypes);
        });

    this.subscriptions.add(
      this.createContractMohaService.originalContract.asObservable().subscribe(rs => {
        if (rs) {
          this.isPlContract = true;
        } else {
          this.isPlContract = false;
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.document.asObservable().subscribe(res => {
        if (res ) {
          this.document = res;
          if (this.document && this.isPlContract && this.document.editProperty) {
            const selectedServiceType = this.createContractMohaService.selectedServiceType.getValue();
            if (selectedServiceType.id !== this.document.serviceType) {
              this.document.serviceType = selectedServiceType.id;
            }
            const selectedEditContent = this.adjustedContents.find(item => item.type === this.document.editProperty);
            if (selectedEditContent) {
              this.adjustedContentSelected = selectedEditContent;
              this.createContractMohaService.adjustedContentSelected.next(this.adjustedContentSelected);
            }
          }
          if(this.createContractMohaService.dataDocumentParentNewUploadContractAttachments.getValue().length > 0){
            this.document.newUploadContractAttachments = this.createContractMohaService.dataDocumentParentNewUploadContractAttachments.getValue();
          }
          if(this.document.dataDocumentParent && this.document.dataDocumentParent.length >0){
            this.dataDocumentParent = this.document.dataDocumentParent
          }
          else if(this.document.parents) {
            this.dataDocumentParent = this.document.parents;
            const lstReferenceContractId = [];
            if(this.dataDocumentParent && this.dataDocumentParent.length > 0){
              this.dataDocumentParent.forEach(ele => {
                lstReferenceContractId.push(ele.id);
              })
            }
            this.document.lstReferenceContractId = lstReferenceContractId;
          }
          if(!this.document.backUpCode && this.isUpdate) {
            this.document.backUpCode = this.document.code;
          }
          // this.createContractMohaService.isConfirmBCT.next(this.document.isConfirmBCT);
          if (res.expiredDate) {
            this.document.expiredDate = new Date(res.expiredDate);
          }
          if (res.effectiveDate) {
            this.document.effectiveDate = new Date(res.effectiveDate);
          }
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.isSubmitData.asObservable().subscribe(rs => {
       if(this.check != 2){
         if (rs && this.btnSubmit) {
           if (this.ngForm.form.invalid) {
             this.ngForm.form.markAllAsTouched();
             this.createContractMohaService.isInvalidInfo.next(true);
           } else {
             this.btnSubmit.nativeElement.click();
           }
         }
       }
      })
    );

    this.subscriptions.add(
      this.createContractMohaService.createContractType.asObservable().subscribe(rs => {
        this.valueSelect = rs;
        this.getServiceTypes(true);
      })
    );
   

    this.subscriptions.add(
      this.createContractMohaService.selectedTemplate.asObservable().subscribe(rs => {
        if (rs) {
          this.onChangeAutoCompletedDocumentType(rs);
        }
      })
    );

    this.subscriptions.add(
      this.createContractMohaService.isOnAutoNumber.subscribe(ref => {
        if (this.isOnAutoNumber === true && ref === false && this.createContractMohaService.currentStep.getValue() === 3) { // cuongnm change step 2->3
          this.isOnAutoNumber = ref
          this.ngForm.form.controls.code.setErrors({ required: true });
          this.createContractMohaService.isInvalidFieldTypeContract.next(true);
          setTimeout(() => {
            const inputElement = document.getElementById('code')
            if (inputElement) {
              inputElement.focus();
            }
          }, 0);
          this.ngForm.form.controls.code.markAsTouched();
        }
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.recordsSharePartner.asObservable().subscribe(res => {
        this.RECORD_SHARE_PARTNER = res
      })
    );
    this.subscriptions.add(
      this.createContractMohaService.contractTerminations.asObservable().subscribe(res => {
        this.contractTerminations = res
      })
    );
  }

  @HostListener('submit')
  onFormSubmit() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.mat-form-field-invalid .mat-input-element,.mat-select-invalid');
    if (invalidElements.length > 0) {
      this.createContractMohaService.isInvalidInfo.next(true);
      invalidElements[0].focus();
    }
    // console.log(this.document);

  }

  ngOnDestroy(): void {
    // this.createContractMohaService.currentStep.unsubscribe();
    // this.warningSmsContractService.statusUpdated.unsubscribe();
    // this.createContractMohaService.document.unsubscribe();
    // this.subscribeSubmitData.unsubscribe();
    this.subscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    // setTimeout(_ => this.focusInput.first.nativeElement.focus());
    setTimeout(_ => {
      // if (window.location.href.includes('add-document')) {
      const serviceTypeId = document.getElementById('serviceTypeId');
      if (serviceTypeId) {
        serviceTypeId.focus();
      }
      const check = JSON.parse(localStorage.getItem('forcusCode'));
      if(check){
        localStorage.removeItem('forcusCode');
        this.documentCodeDuplicateHanlder(1);
      }
      // }
    });
    this.formChangesSubscription = this.ngForm.form.statusChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.setFormChanging(true);
        this.createContractMohaService.isDirty = true;
      }
    });

    // Change state first edit loaded to false after 3s because there is no way to know
    // which observable finish last.
    setTimeout(_ => this.firstEditLoaded = false, 7000);
  }

  onClickUpload() {
    // console.log('click upload');
  }

  public async getFile(e) {
    if (typeof (FileReader) !== 'undefined') {
      const file: File = e.target.files[0];

      if (file.type !== 'application/pdf') {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.only_accept_pdf'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
          if (this.pdfSrc == null || this.pdfSrc.length === 0) {
            this.valueSelect = null;
          }
        }
      } else {
        if (file.size <= 10485760) {
          await this.checkContentTypeThenAddFile(file);
        } else {
          if (!this.toastr.findDuplicate(this.message.getMessage('validation.file'), true, true)) {
            this.toastr.error(this.message.getMessage('validation.file'));
            if (this.pdfSrc == null || this.pdfSrc.length === 0) {
              this.valueSelect = null;
            }
          }
        }
      }
      // this.reset();
    }
    return true;
  }

  private async checkContentTypeThenAddFile(file: File): Promise<boolean> {
    const ct = await FileUtils.getContentType(file);
    let r = false;
    if (ContentType.PDF === ct) {
      r = true;
      this.fileUpload = file;
      const reader = new FileReader();
      // tslint:disable-next-line:no-shadowed-variable
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      reader.readAsArrayBuffer(file);
      this.setFormChanging(true);
      this.valueSelect = 1;
    } else {
      this.toastr.error(this.message.getMessage('messages.only_accept_pdf'));
      this.valueSelect = null;
    }
    return new Promise((resolve, reject) => resolve(r));
  }

  public onAddAttachFile() {
    const arrAttachBindToDialog = [];
    this.document.newUploadContractAttachments.forEach(element => {
      arrAttachBindToDialog.push(element);
    });

    this.dialogRefFileAttachMohaComponent = this.dialog.open(FileAttachMohaComponent, {
      width: '40%',
      data: {
        attachments: this.attachments,
        customerName: this.customer.customerName,
        newUploadContractAttachments: arrAttachBindToDialog
      }
    });

    this.dialogRefFileAttachMohaComponent.afterClosed().subscribe(rs => {
      if (rs) {
        this.setFormChanging(true);
        this.document.contractAttachments = this.dialogRefFileAttachMohaComponent.componentInstance.onAttachFile();
        this.document.newUploadContractAttachments
          = this.dialogRefFileAttachMohaComponent.componentInstance.uploadMultiFileAttachmentsMohaComponent.arrAttachments;
      } else {
        this.attachments = this.dialogRefFileAttachMohaComponent.componentInstance.rollBackAttach();
      }
    });
  }

  /**
   *  Refresh input
   */
  private reset() {
    this.inputUploadFile.nativeElement.value = '';
  }

  // Function handler set sự thay đổi trên form.
  setFormChanging(changingStatus: boolean): void {
    this.isFormChanging = changingStatus;
    this.hasChange.emit(changingStatus);
  }

  public onValidateGeneralInfo() {
    const invalid = [];
    const controls = this.ngForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push({
          name,
          error: controls[name].errors
        });
      }
    }
    // console.log(invalid);
    // console.log(this.document.parentId);
    // console.log(this.document);
    this.panels.forEach((x, index) => {
      if (index === 0) {
        x.open();
      }
    });
    this.blockUI.stop();
    // if (!this.ngForm.form.valid) {
    //   setTimeout(() => {
    //     this.accordion.openAll();
    //   }, 200);
    // }
  }

  uploadFile(successCallback?: () => void, noUpload?: () => void) {
    const fileUpload = this.document.newUploadContractAttachments.filter(
      element => element.name !== undefined || element.File != null);

    const arrFileUpload = [];

    fileUpload.forEach(element => {
      if (element.File != null) {
        arrFileUpload.push(element.File);
      } else {
        arrFileUpload.push(element);
      }
    });

    if (arrFileUpload.length > 0) {
      this.documentService.uploadMultiFileAttachForDocument(arrFileUpload)
        .subscribe(rs => {
          if(rs && rs.success){
            this.uploadFileSuccess(rs, successCallback);
          }else{
            this.toastr.error(rs.message);
            if(rs.code == ErrorCode.MaxSizeError){
              this.maxSize = rs.data > 0 ? rs.data : 10*1024*1024;
            }
          }
        });
    } else {
      noUpload();
    }
  }

  // After upload success
  private uploadFileSuccess(rs, successCallback: (data) => void) {
    for (let i = 0; i < rs.data.length; i++) {
      this.document.newUploadContractAttachments.push(rs.data[i]);
    }

    this.document.newUploadContractAttachments = this.document.newUploadContractAttachments.filter(
      arrAttachments => arrAttachments.fileName !== undefined);

    successCallback(this.document.newUploadContractAttachments);
  }

  public onChangeAutoCompletedDocumentTypeParent() {
    if (this.selectedDocumentTypeParent === null || this.selectedDocumentTypeParent === undefined) {
      this.document.parentId = null;
      this.selectedDocumentTypeParent = null;
      this.setFormChanging(true);
    } else {
      this.document.parentId = this.selectedDocumentTypeParent.id;

      if (!this.firstEditLoaded) {
        this.setFormChanging(true);
      }

      // Change customer information panel when change document type parent
      if (this.document.parentId !== '') {
        // Get data of parent document to bind customer data
        this.documentService.getDocumentById(this.document.parentId).subscribe(rs => {
          // console.log('onChangeAutoCompletedDocumentTypeParent', rs);
          if (!rs.data || !rs.data.contractDTO) {
            return;
          }

          // console.log('this.document.serviceType truoc ', this.document.serviceType);
          this.document.serviceType = rs.data.contractDTO.serviceType;
          // console.log('this.document.serviceType sau ', this.document.serviceType);

          // If user changes parent customer's email or customer's phone of parent document then
          // get this data and bind to child document
          if (rs.data.contractDTO.email) {
            this.parentDocumentMetaData.email = rs.data.contractDTO.email;
          }
          if (rs.data.contractDTO.phone) {
            this.parentDocumentMetaData.phone = rs.data.contractDTO.phone;
          }

          if (this.document.typeId === 0 || this.valueSelect === 0) {
            // this.onChangePanelData.next({
            //   parentDocumentData: rs.data.contractDTO
            // });
          } else if (rs.data.contractDTO.serviceType) {
            this.getServiceTypeById(rs.data.contractDTO.serviceType);
          }
        });
      }
    }
  }

  getServiceTypeById(id) {
    this.commonService.getServiceType(id).subscribe(result => {
      this.document.serviceType = result.data.id;
    });
  }

  checkExistedInternalUser(id: string) {
    const existedList = this.dataDocumentParent.filter((e) => {
      return e.id === id;
    });

    return (existedList.length > 0);
  }

  autocompleteInternalUserSelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedInternalUser(model.id)) {
        this.dataDocumentParent = [
          ...this.dataDocumentParent,
          {
            code: model.code,
            name: model.name,
            id: model.id,
            typeId:model.typeId,
            isContractShare: model.isContractShare,
            contractTerminationStatus: model.contractTerminationStatus,
            status: model.status
          }
        ];
        this.document.dataDocumentParent = this.dataDocumentParent;
        const lstReferenceContractId = [];
        if(this.dataDocumentParent && this.dataDocumentParent.length > 0){
          this.dataDocumentParent.forEach(ele => {
            lstReferenceContractId.push(ele.id);
          })
        }
        this.document.lstReferenceContractId = lstReferenceContractId;
        this.createContractMohaService.dataReferenceContract.next(this.dataDocumentParent);
      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_document_forward_duplicate'), model.name));
      }
    }
  }
  getParentContractNew(e, value?: string) {

    this.parentContracts = [];
    if (e.inputType.includes('insert') || e.inputType.includes('delete')) {
      // this.reset('docParent');
      if (!this.inputInternalDocumentsValue) {
        this.parentContracts = [];
        return;
      }
      if (this.timeOutQueryServer1) {
        clearTimeout(this.timeOutQueryServer1);
      }
      this.timeOutQueryServer1 = setTimeout(() => {
      const data = {
        nameOrCode: this.inputInternalDocumentsValue.trim(),
        contractId: ''
      };
      this.nzCheckLoadingParty1 = true;
      this.digitalContractService.getContractParent(data)
        .subscribe(res => {
          if (res.data && res.success) {
            this.parentContracts = res.data;
            const height = 45 * this.parentContracts.length;
            if (this.parentContracts.length) {
              if (height <= 250) {
                this.listParentHeight = -(height + 2 - 30);
              } else {
                this.listParentHeight = -220;
              }
            } else {
              this.listParentHeight = -17;
            }
          } else {
            this.toastr.error(res.message);
          }
          this.nzCheckLoadingParty1 = false;
        });
    },500) }else return;
  }
  onClickDeleteElementRecordInternalUser(id: any): void {

    this.dataDocumentParent = this.dataDocumentParent.filter(d => d.id !== id);
    this.document.dataDocumentParent = this.dataDocumentParent;
    const lstReferenceContractId = [];
    if(this.dataDocumentParent && this.dataDocumentParent.length > 0){
      this.dataDocumentParent.forEach(ele => {
        lstReferenceContractId.push(ele.id);
      })
    }
    this.document.lstReferenceContractId = lstReferenceContractId
    this.createContractMohaService.dataReferenceContract.next(this.dataDocumentParent);
  }
  private checkmatched(listFileName: string[], name: string) {
    const filenameSplit = name.split('.')
    const type = filenameSplit.pop();
    const fileName = filenameSplit.join('.');
    let fileNameConverted = fileName + '.' + type;
    let k = 1;
    if (listFileName.length > 0) {
      while (listFileName.includes(fileNameConverted)) {
        fileNameConverted = fileName + '(' + k + ').' + type;
        k++;
      }
    }


    return fileNameConverted;
  }
  viewContract(ala,data?) {
    if(ala.typeId == 2){
      this.blockUI.start();
      this.digitalContractService.getContractById(ala.id).subscribe(async res => {
        if (res.data && res.success) {
          this.contractView.contractName = res.data.code + ' - ' + res.data.name;
          const attachments = res.data.contractAttachments;
          if (attachments.length > 0) {
            this.blockUI.start();
            const nameList = [];
            const idList = [];
            const listFileSize = [];

            for (let file of attachments) {
              nameList.push(this.checkmatched(nameList, file.fileName));
              idList.push(file.id)
              listFileSize.push(file.fileSize)
              console.log(file, 'file file');
              if (idList.length === attachments.length) {
                this.blockUI.stop();
              }
            }
            this.contractView.filesName = nameList;
            this.contractView.id = idList;
            this.contractView.listFileSize = listFileSize;
            this.isShowReferencePdf.next(true);
            this.contractView.idDocument = ala.id;
            this.contractView.attachments = attachments;
            if(data){
              this.contractView.checkMan = data;
            }
            const dialog = this.dialog.open(ViewContractComponent, {
              data: this.contractView,
              width: '90%',
              minHeight: '90%'
            });
            dialog.afterClosed().subscribe(res => {
              this.isShowReferencePdf.next(false);
            })
            // this.blockUI.stop();

          }
        } else {
          this.toastr.error(res.message);
        }
      });
      this.blockUI.stop();

    }
    else{
      this.viewDocumentReferenceNew(ala);
    }

  }
  public viewDocumentReference() {
    const data: ViewDocumentReferenceDto = {
      mainContractId: null,
      referenceContractId: this.selectedDocumentTypeParent.id,
      pdfFilePath: this.selectedDocumentTypeParent.filePath
    };

    this.isShowReferencePdf.next(true);
    this.createContractMohaService.isShowPopupPdf.next(true);
    if (this.selectedDocumentTypeParent && this.selectedDocumentTypeParent.id) {
      const dialogRef = this.dialog.open(ViewDocumentReferenceComponent, {
        width: '90%',
        minHeight: '90%',
        data,
      });
      dialogRef.afterClosed().subscribe(rs => {
        enableFormFields();
        enableFormInput();
        this.isShowReferencePdf.next(false);
        this.createContractMohaService.isShowPopupPdf.next(false);
        // document.getElementById('focusSelect').focus();
      });
    } else {
      if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
        this.toastr.error(this.message.getMessage('messages.not_documentId'));
      }
    }
  }
  public viewDocumentReferenceNew(res) {
    // public getParentDocumentById() {
    this.documentService.getDocumentById(res.id).subscribe(rs => {
      this.selectedDocumentTypeParent = {
        id: rs.data.contractDTO.id,
        name: rs.data.contractDTO.name,
        code: rs.data.contractDTO.code,
        filePath: rs.data.contractDTO.filePath
      };
      const data: ViewDocumentReferenceDto = {
        mainContractId: null,
        referenceContractId: res.id,
        pdfFilePath: this.selectedDocumentTypeParent.filePath
      };
      this.isShowReferencePdf.next(true);
      this.createContractMohaService.isShowPopupPdf.next(true);
      if (this.selectedDocumentTypeParent && this.selectedDocumentTypeParent.id) {
        const dialogRef = this.dialog.open(ViewDocumentReferenceComponent, {
          width: '90%',
          minHeight: '90%',
          data,
        });
        dialogRef.afterClosed().subscribe(rs => {
          this.isShowReferencePdf.next(false);
          this.createContractMohaService.isShowPopupPdf.next(false);
        });
      } else {
        if (!this.toastr.findDuplicate(this.message.getMessage('messages.not_documentId'), true, true)) {
          this.toastr.error(this.message.getMessage('messages.not_documentId'));
        }
      }
    });
    // }

  }
  private getDocumentTypeById(documentTypeId: any) {
    this.documentService.getDocumentTypeById(documentTypeId).subscribe(rs => {
      // CHECK HERE
      if (this.valueSelect === 0) {
        // save template for use later
        this.templateDocument = rs;
        // reset parent contract data
        this.document.parentId = null;
        this.selectedDocumentTypeParent = null;

        this.onChangeTemplate.next(rs);
      }
    });
  }

  // public submitValidate() {
  //   // Kiểm tra nếu chư thiết lập Luồng ký chủ thể && Luồng Ký/Duyệt
  //   // khi this.btnSubmit.nativeElement.click đã validate 1 lần rồi, nên không cần validate ở đây nữa
  //   // this.validateSetupParty();
  //   // this.validateErrorSetUser();
  //   this.btnSubmit.nativeElement.click();
  // }

  public onChangeAutoCompletedDocumentType(data) {
    this.selectedDocumentType = data;
    if(data.serviceType){
      this.document.serviceType = data.serviceType;
    }
    if (this.selectedDocumentType === null || this.selectedDocumentType === undefined) {
      this.document.documentTypeEnterpriseId = '';
      if (this.parentDocument) {
        this.parentDocument.clearValue();
      }
    } else {
      // Document type id of current document
      this.document.documentTypeEnterpriseId = this.selectedDocumentType.id;

      // Get the template of document type
      if (this.document.typeId === 0 || this.valueSelect === 0) {

        this.documentService.getDocumentTypeById(this.selectedDocumentType.id).subscribe(rs => {
          // CHECK HERE
          // save template for use later
          this.templateDocument = rs;
          this.onChangeTemplate.next(rs);
        });
        // this.getDocumentTypeById(this.selectedDocumentType.id);

        if (this.selectedDocumentType.parentId != null) {
          this.selectedDocumentTypeParent = null;
        } else { // If template is not appendix
          // Hide autocompleted of parent document
          this.document.parentId = '';
        }

        // Clear parent document's data in case of creating appendix
        if (this.parentDocument) {
          this.parentDocument.clearValue();
        }
      }
      //check neu doi mau && file thi khong goi lai api
      if (!(this.createContractMohaService.isChangeTypeDocAndTemp && this.createContractMohaService.isChangeTypeDocAndTemp.getValue())) {
        this.getServiceTypeByDocumentTypeId(this.selectedDocumentType.id);
      }
    }
  }

  getServiceTypeByDocumentTypeId(idDocumentType: string) {
    this.documentTypeService.getServiceTypeByDocumentTypeId(idDocumentType).subscribe(rs => {
      if (rs.data) {
        //man 1 gan isOnAutoNumber
        if (this.current == 0) {
          this.isOnAutoNumber = rs.data.isOnAutoNumber;
          if (this.isOnAutoNumber && this.isUpdate == false) {
            this.createContractMohaService.isOnAutoNumber.next(rs.data.isOnAutoNumber);
            this.document.code = ''
          }
        }
        this.createContractMohaService.selectedServiceType.next(rs.data);
        this.document.serviceType = rs.data.id;
      }
    });
  }

  // Change select document type
  public onChangeSelect(value: number) {
    this.valueSelect = value;
    this.getServiceTypes();

    if (this.valueSelect === 1) {
      this.pdfSrc = '';
      // this.document.parentId = '';
      // this.selectedDocumentTypeParent = null;
      this.autocompleteComponent.clearValue();
    } else if (this.valueSelect === 0 && this.document.documentTypeEnterpriseId) {
      this.document.parentId = '';
      this.selectedDocumentTypeParent = null;
      this.autocompleteComponent.clearValue();
      this.getDocumentTypeById(this.document.documentTypeEnterpriseId);
    }
  }

  getServiceTypes(isCheckStep3: boolean = false) {
    //check nếu cùng form update ko load lại loại hợp đồng nữa
    if (this.createContractMohaService.isUpdateDocument && this.createContractMohaService.serviceTypes) {
      this.serviceTypes = this.createContractMohaService.serviceTypes;
    }
    //check neu doi mau && file thi khong goi lai api
    // if (!(this.createContractMohaService.isChangeTypeDocAndTemp && this.createContractMohaService.isChangeTypeDocAndTemp.getValue())) {
      this.documentMohaService.getServiceTypes(this.document.enterpriseId).subscribe(rs => {
        if (rs == null || rs.data == null) {
          return 0;
        }
        if (this.createContractMohaService.isUpdateDocument && this.createContractMohaService.serviceTypes) {
          this.serviceTypes = this.createContractMohaService.serviceTypes;
        } else {
          this.serviceTypes = rs.data;
          this.createContractMohaService.serviceTypes = this.serviceTypes;
        }
        const obj = this.serviceTypes.find(item => item.id === this.document.serviceType)
        if(obj && obj.employmentContractTerm){
          this.document.employmentContractTerm = obj.employmentContractTerm
          this.document.laborContractType = obj.employmentContractTerm == 'LIMITED' ? 'Xác định thời hạn' : 'Không xác định thời hạn'
          this.createContractMohaService.employmentContractTerm.next(obj.employmentContractTerm)
        }
        if (obj && obj.isOnAutoNumber) {
          if(this.isUpdate || this.flagCopy){
            this.isOnAutoNumber = obj.isOnAutoNumber;
            this.createContractMohaService.isOnAutoNumber.next(this.isOnAutoNumber);
            if(this.isUpdate && this.document.code == '') {
              this.document.code = this.document.backUpCode;
            }
          }else{
            this.document.code = '';
            this.isOnAutoNumber =this.createContractMohaService.isOnAutoNumber.getValue();
          }
          if (!this.configAutoNumber) {
            if (this.document.code && this.isUpdate) {
              this.createContractMohaService.configAutoNumber.next(this.document.code);
            } else {
              //neu man dau them moi thi moi gan code = ''
              if(this.current == 0) {
                this.document.code = '';
              }
              this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(obj.configAutoNumber));
            }
            this.configAutoNumber = this.createContractMohaService.configAutoNumber.getValue();
          } else if (!this.createContractMohaService.configAutoNumber.getValue()) {
            if (this.document.code && this.isUpdate) {
              this.createContractMohaService.configAutoNumber.next(this.document.code);
            } else {
              this.createContractMohaService.configAutoNumber.next(this.configAutoNumber);
            }
          }
          if (this.isUpdate && this.refreshContractCode) {
            this.document.code = '';
            this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(obj.configAutoNumber));
          }
        } else {
          this.isOnAutoNumber = false;
          this.createContractMohaService.isOnAutoNumber.next(false);
          //ma ban dau neu la cap nhat ko danh so
          if(this.isUpdate) {
            if(!this.document.backUpCode) {
              this.document.backUpCode = this.document.code;
            }
          } else {
            //khong danh so
            this.createContractMohaService.configAutoNumber.next('');
          }
        }
        if (this.valueSelect !== 0) {
          this.serviceTypes = this.serviceTypes.filter((data) => data.type != 2);
          this.createContractMohaService.serviceTypes = this.serviceTypes;
        }
        if (isCheckStep3) {
          if (this.valueSelect !== 0 && this.serviceTypes && !this.serviceTypes.find((data) => data.id === this.document.serviceType)) {
            this.document.serviceType = null;
            document.getElementById('serviceTypeId').focus();
            this.createContractMohaService.isInvalidFieldTypeContract.next(true);
          }
        }

        if (this.createContractMohaService.isUpdateDocument) {
          this.createContractMohaService.serviceTypes = this.serviceTypes.slice();
        }
        this.filteredServiceTypes.next(this.serviceTypes.slice());
      });


  }


  getServiceTypeWhenAddDocument (res: any) {
    this.documentTypeService.getServiceTypesMoha(this.document.enterpriseId, true).subscribe(rs => {
      if (rs == null || rs.data == null) {
        return 0;
      }
      this.serviceTypes = rs.data;
      this.filteredServiceTypes.next(this.serviceTypes.slice());
      this.createContractMohaService.serviceTypes = this.serviceTypes;
      const objectServiceType = this.serviceTypes.find(item => item.id == res.data);
      this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
      if (objectServiceType && objectServiceType.isOnAutoNumber) {
        if (!this.configAutoNumber) {
          if (this.document.code && this.isUpdate) {
            this.createContractMohaService.configAutoNumber.next(this.document.code);
          } else {
            this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(objectServiceType.configAutoNumber));
          }
        }
        if (!this.isUpdate) {
          this.document.code = '';
          this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(objectServiceType.configAutoNumber));
        }
        else if (this.isUpdate) {
          //cap nhat doi loai thi quay ve ma ban dau
          if(this.configAutoNumber) {
            this.document.code = this.configAutoNumber;
          }
          if(this.document.backUpCode) {
            this.document.code = this.document.backUpCode;
          }
        }
      } else {
        if (!this.isUpdate) {
          this.createContractMohaService.configAutoNumber.next('');
        }
      }
      if(this.document.code && this.isUpdate){
        this.createContractMohaService.configAutoNumber.next(this.document.code);
      }
      this.checkFocus = false;
      this.createContractMohaService.isInvalidFieldTypeContract.next(false);
      this.createContractMohaService.isOnAutoNumber.next(this.isOnAutoNumber);
    });
    if (res) {
      this.document.serviceType = res.data;
    }
  }

  selectedAdjustChange(event) {
    console.log(event);
    const selectedEditContent = this.adjustedContents.find(item => item.type === event.value);
    if (selectedEditContent) {
      this.adjustedContentSelected = selectedEditContent;
      this.createContractMohaService.adjustedContentSelected.next(this.adjustedContentSelected);
    }
  }

  selectedChange(event) {
    // if(this.configAutoNumber){
    //   this.document.code = this.configAutoNumber;
    // }
    if(this.isUpdate && this.refreshContractCode) {
      this.document.code = this.configAutoNumber;
    }
    this.refreshContractCode = false;
    this.createContractMohaService.refreshContractCode.next(this.refreshContractCode);
    this.createContractMohaService.exampleContractCodeAutoNumber.next('');
    const objectServiceType = this.serviceTypes.find(item => item.id == event.value);
    this.createContractMohaService.selectedServiceType.next(objectServiceType);
    this.isOnAutoNumber = objectServiceType.isOnAutoNumber;
    if(objectServiceType && objectServiceType.employmentContractTerm){
      this.document.employmentContractTerm = objectServiceType.employmentContractTerm
      this.document.laborContractType = objectServiceType.employmentContractTerm == 'LIMITED' ? 'Xác định thời hạn' : 'Không xác định thời hạn'
      this.createContractMohaService.employmentContractTerm.next(objectServiceType.employmentContractTerm)
    }
    if (objectServiceType && objectServiceType.isOnAutoNumber) {
      if (!this.configAutoNumber) {
        if (this.document.code && this.isUpdate) {
          this.createContractMohaService.configAutoNumber.next(this.document.code);
        } else {
          this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(objectServiceType.configAutoNumber));
        }
      }
      if (!this.isUpdate) {
        this.document.code = '';
        this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(objectServiceType.configAutoNumber));
      }
      else if (this.isUpdate) {
        //cap nhat doi loai thi quay ve ma ban dau
        if(this.configAutoNumber) {
          this.document.code = this.configAutoNumber;
        }
        if(this.document.backUpCode) {
          this.document.code = this.document.backUpCode;
        }
      }
    } else {
      if (!this.isUpdate) {
        this.createContractMohaService.configAutoNumber.next('');
      }
    }
    if(this.document.code && this.isUpdate){
      this.createContractMohaService.configAutoNumber.next(this.document.code);
    }
    this.checkFocus = false;
    this.createContractMohaService.isInvalidFieldTypeContract.next(false);
    this.createContractMohaService.isOnAutoNumber.next(this.isOnAutoNumber);
  }

  // public bindDataToPanel(dataDocument, serviceTypeId = null, typeCopy?: any, flagCopy?: any) {
  //   this.document = dataDocument;
  //   // console.log('this.document bindDataToPanel', this.document);
  //
  //   if (this.document.customerId != null) {
  //     this.getCustomerById(this.document.customerId, true, (customer) => {
  //       this.selectCustomer(customer);
  //       this.autoComplete.formControl.setValue(this.selectedCustomer);
  //       this.bindDataFromAddComponent = true;
  //     });
  //
  //     this.getAttachmentOfCustomer(this.document.customerId);
  //   }
  //
  //   this.getServiceTypes();
  //
  //   if (this.document.typeId === 1) {
  //     if (typeCopy && typeCopy === 0 || !flagCopy) {
  //       this.valueSelect = 1;
  //       this.viewPdf(this.document.id);
  //       this.getServiceTypeById(dataDocument.serviceType);
  //       if (this.document.parentId) {
  //         this.documentService.getDocumentById(this.document.parentId).subscribe(rs => {
  //           this.selectedDocumentTypeParent = {
  //             id: rs.data.contractDTO.id,
  //             name: rs.data.contractDTO.name,
  //             code: rs.data.contractDTO.code,
  //             filePath: rs.data.contractDTO.filePath
  //           };
  //         });
  //       } else {
  //         this.hideDocumentParent = true;
  //       }
  //     }
  //   } else {
  //     this.valueSelect = 0;
  //     this.findDocumentById(this.document.documentTypeEnterpriseId);
  //     if (this.document.parentId) {
  //       this.documentService.getDocumentById(this.document.parentId).subscribe(rs => {
  //         this.selectedDocumentTypeParent = {
  //           id: rs.data.contractDTO.id,
  //           name: rs.data.contractDTO.name,
  //           code: rs.data.contractDTO.code,
  //           filePath: rs.data.contractDTO.filePath
  //         };
  //         this.parentDocument.formControl.setValue(this.selectedDocumentTypeParent);
  //       });
  //     }
  //   }
  //
  //   if (this.route.snapshot.queryParams.flagCopy) {
  //     this.getListEnterpriseUserSignForCopy();
  //   } else {
  //     this.getListEnterpriseUserSignBydocumentId();
  //   }
  //   // bindDataToPanel
  // }

  public getDocumentById(data, serviceType = null) {
    this.document = data;
    if(this.document.dataDocumentParent && this.document.dataDocumentParent.length >0){
      this.dataDocumentParent = this.document.dataDocumentParent
    }
    else if(this.document.parents) {
      this.dataDocumentParent = this.document.parents;
      const lstReferenceContractId = [];
      if(this.dataDocumentParent && this.dataDocumentParent.length > 0){
        this.dataDocumentParent.forEach(ele => {
          lstReferenceContractId.push(ele.id);
        })
      }
      this.document.lstReferenceContractId = lstReferenceContractId;
    }
    if (serviceType) {
      this.document.serviceType = serviceType.id;
    }
    this.getServiceTypes();
  }

  public setAttachFile(rs) {
    this.attachments = [];

    rs.forEach(element => {
      let check = false;
      let elementDocData: any;
      this.document.contractAttachments.forEach(elementDoc => {
        if (element.path === elementDoc.path) {
          check = true;
          elementDocData = elementDoc;
        }
      });

      if (check) {
        this.attachments.push({
          id: elementDocData.id,
          fileSize: elementDocData.fileSize,
          fileName: elementDocData.fileName,
          path: elementDocData.path,
          active: true
        });
      } else {
        this.attachments.push({
          id: null,
          fileSize: element.fileSize,
          fileName: element.fileName,
          path: element.path,
          active: false
        });
      }
    });
  }

  initDataUpdate(document, serviceType) {
    this.document = document;
    if(this.document.dataDocumentParent && this.document.dataDocumentParent.length >0){
      this.dataDocumentParent = this.document.dataDocumentParent
    }
    else if(this.document.parents) {
      this.dataDocumentParent = this.document.parents;
      const lstReferenceContractId = [];
      if(this.dataDocumentParent && this.dataDocumentParent.length > 0){
        this.dataDocumentParent.forEach(ele => {
          lstReferenceContractId.push(ele.id);
        })
      }
      this.document.lstReferenceContractId = lstReferenceContractId;
    }
    if (serviceType) {
      this.document.serviceType = serviceType.id;
    }
    // this.getListEnterpriseUserSignBydocumentId();
    this.getServiceTypes();
  }

  private initData() {
    this.selectedDocumentType = { id: '', name: '', parentId: null };
    this.document = {
      id: '',
      code: '',
      name: '',
      parentId: '',
      enterpriseId: localStorage.getItem('enterpriseId'),
      documentTypeEnterpriseId: '',
      customerId: '',
      customerEnterpriseId: '',
      filePath: '',
      description: '',
      assignUserId: 0,
      submitedTo: 0,
      typeId: null,
      jsonData: '',
      email: '',
      phone: '',
      createdBy: '',
      finishDate: null,
      documentTypeContent: '',
      expiredDate: null,
      contractAttachments: [],
      newUploadContractAttachments: [],
      serviceType: null,
      enterpriseSign: [],
      userSign: [],
      signPage: 1,
      fileNameUpdate: '',
      fileSizeUpdate: '',
      version: '',
      isSkipVersion: null,
      cancelTime: '',
      cancelReason: '',
      cancelUserFullName: '',
      fields: null,
      templateFilePath: '',
      outputContentBase64: '',
      outputFilePath: '',
      signatures: null,
      mainContractAttachments: null,
      contractShares: null,
      isConfirmBCT: false,
      summary: '',
      contractSharePartners: [],
      effectiveDate: '',
      laborContractType: '',
      employmentContractTerm: '',
      editProperty: null,
      dataOriginalContract: [],
      status: null,
      isHaveNoCreatedSide: null
    };

    if (this.isNotAttestedUser) this.document.isConfirmBCT = false;

    this.defaultCustomerModel = {
      customerAccountNumber: '',
      customerAddress: '',
      customerAdminUser: '',
      customerAttachments: [],
      customerBankBranch: '',
      customerBankName: '',
      customerBank: '',
      customerBirthday: null,
      customerCertificateId: 0,
      customerCertificateNo: '',
      customerCityId: null,
      customerId: '',
      customerType: 0,
      customerDistrictId: null,
      customerEmail: '',
      customerReceiverEmail: '',
      customerEnterpriseId: '',
      customerFax: '',
      customerIssuedAt: '',
      customerIssuedDate: null,
      customerIssuedDay: null,
      customerIssuedMonth: null,
      customerIssuedYear: null,
      customerName: '',
      customerPhone: '',
      customerReceiverPhone: '',
      customerPosition: '',
      customerPrimaryEmail: '',
      customerRepresentative: '',
      customerRepresentativeCertificateId: 0,
      customerRepresentativeCertificateNo: '',
      customerRepresentativeIssuedAt: '',
      customerRepresentativeIssuedDate: null,
      customerSex: null,
      customerTaxCode: '',
      customerTaxCode_01: '',
      customerTaxCode_02: '',
      customerTaxCode_03: '',
      customerTaxCode_04: '',
      customerTaxCode_05: '',
      customerTaxCode_06: '',
      customerTaxCode_07: '',
      customerTaxCode_08: '',
      customerTaxCode_09: '',
      customerTaxCode_10: '',
      customerTaxCode_11: '',
      customerTaxCode_12: '',
      customerTaxCode_13: '',
      customerTaxCode_14: '',
      customerWardId: null,
      customerContacter: '',
      customerContacterApartmantNumber: '',
      customerContacterStreetName: '',
      customerContacterGroup: '',
      customerContacterWard: '',
      customerContacterDistrict: '',
      customerContacterCity: '',
      customerContacterPhone: '',
      customerContacterEmail: '',
      customerAddressUsing: '',
      customerIndividualOrRepresentativeCertificate: '',
      customerIndividualOrRepresentativeIssuedAt: '',
      customerIndividualOrRepresentativeIssuedDate: '',
      customerBusinessCertificateNo: '',
      customerBusinessCertificateIssuedAt: '',
      customerBusinessCertificateIssuedDate: '',
      customerBusinessCertificateIssuedDay: '',
      customerBusinessCertificateIssuedMonth: '',
      customerBusinessCertificateIssuedYear: '',
      customerIndividualOrRepresentativeIssuedDay: '',
      customerIndividualOrRepresentativeIssuedMonth: '',
      customerIndividualOrRepresentativeIssuedYear: '',
      customerIndividualOrRepresentativeIssuedShortYear: ''
    };

    this.customer = { ...this.defaultCustomerModel };

    this.recordSelectedEnterprise = {
      order: null,
      enterpriseId: null,
      enterpriseName: '',
      email: '',
      phone: null,
      status: null,
      isCreatedSide: null,
      customerId: '',
      name: '',
      certificateNo: '',
      useDataForTemplate: false,
      isSignNoLogin: false
    };

    this.userInformation = {
      order: null,
      userId: null,
      enterpriseSignId: null,
      name: '',
      email: '',
      role: null,
      phone: '',
      isCreatedSide: true
    };

    // this.defaultEnterprises = {
    //   order: null,
    //   enterpriseId: null,
    //   enterpriseName: '',
    //   email: '',
    //   phone: null,
    //   status: null,
    //   isCreatedSide: null,
    //   customerId: '',
    //   name: '',
    //   certificateNo: '',
    //   useDataForTemplate: false,
    //   isSignNoLogin: false
    // };
    // this.createContractMohaService.isConfirmBCT.next(this.document.isConfirmBCT)
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';
  }

  public documentCodeDuplicateHanlder(rs: any): void {
    if (this.ngForm.form.controls.code) {
      this.ngForm.form.controls.code.setErrors({ duplicate: true });
      this.ngForm.form.controls.code.markAsTouched();
      document.getElementById('code').focus();
    }
  }

  onChangeSignPage() {
    if (this.document.signPage < 1) {
      this.document.signPage = 1;
    }
    if (!Number.isInteger(this.document.signPage)) {
      this.document.signPage = Math.floor(this.document.signPage);
    }
    if (this.inputSignPage) {
      this.inputSignPage.nativeElement.value = this.document.signPage;
    }
  }

  findDocumentById(id: string) {
    this.documentTypeService.findById(id).subscribe(rs => {
      this.selectedDocumentType = {
        id: rs.data.id,
        name: rs.data.name,
        parentId: rs.data.parentId ? rs.data.parentId : null
      };
      //console.log('paosdp',this.selectedDocumentType )
      // this.documentTypeAuto.formControl.setValue(this.selectedDocumentType);
    });
  }

  downloadFile(id, name) {
    this.commonService.downloadDocumentFile(id).subscribe(rs => {
      this.downLoadFile(rs, 'application/octet-stream', name);
    });
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], { type });
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  onNewUploadChange(event) {
    if (event === true) {
      this.setFormChanging(true);
    }
    // console.log(event);
  }

  expiredDateChange(value) {
    if (value == null || value === '' || value === undefined) {
      this.checkExpiredReq = true;
      this.ngForm.controls['expiredDate'].setValue(null);
    } else {
      this.checkExpiredReq = false;
    }
  }

  isConfirmBCTChange() {
    this.checkFocus = false
    // this.createContractMohaService.isConfirmBCT.next(this.document.isConfirmBCT);
  }

  createTplModal(tplTitle: TemplateRef<{}>, tplContent: TemplateRef<{}>, tplFooter: TemplateRef<{}>): void {
    this.tplModal = this.modalService.create({
      nzTitle: tplTitle,
      nzContent: tplContent,
      nzFooter: tplFooter,
      nzMaskClosable: true,
      nzClosable: true,
      nzOnOk: () => console.log('Click ok')
    });
  }

  destroyTplModal(): void {
    setTimeout(() => {
      this.tplModal.destroy();
    }, 300);
  }

  onSubmit(event: Event) {
    if (this.ngForm.invalid) {
      this.onValidateGeneralInfo()
    } else {
      event.preventDefault();
      this.submitData();
    }
  }

  onRefreshContractCode() {
    if (this.isOnAutoNumber && Boolean(this.isUpdate) == true) {
      if(this.current == 0){
        this.document.backUpCode = this.document.code;
        this.document.code = '';
      }
      else{
        this.document.tempCode=this.document.code;
        this.document.backUpCode = this.document.code;
        this.document.code = ''
      }
    }
    this.refreshContractCode = true;
    this.createContractMohaService.refreshContractCode.next(this.refreshContractCode);
    const obj = this.serviceTypes.find(item => item.id === this.document.serviceType);
    if (obj && obj.configAutoNumber) {
      //file
      if(this.valueSelect !== 0) {
        if(this.configAutoNumber) {
          //cap nhat an refresh luu ma ban dau vao configAutoNumber
          this.createContractMohaService.configAutoNumber.next(this.configAutoNumber);
        } else {
          this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(obj.configAutoNumber));
        }
        //them vi du vao khung mahd
        this.createContractMohaService.exampleContractCodeAutoNumber.next(this.commonService.convertConfigAutoNumber(obj.configAutoNumber));
      }
      //mau
      if(this.valueSelect === 0) {
        this.createContractMohaService.configAutoNumber.next(this.commonService.convertConfigAutoNumber(obj.configAutoNumber));
      }

    }
  }

  submitData() {
    // console.log(this.document);
    // this.btnSubmit.nativeElement.click();
    this.createContractMohaService.isGeneralInfoValid.next(true);
    this.document.dataDocumentParent = this.dataDocumentParent;
    const lstReferenceContractId = [];
    if(this.dataDocumentParent && this.dataDocumentParent.length > 0){
      this.dataDocumentParent.forEach(ele => {
        lstReferenceContractId.push(ele.id);
      })
    }
    this.document.lstReferenceContractId = lstReferenceContractId
    this.document.dataDocumentParent = this.dataDocumentParent;

    // this.createContractMohaService.dataDocumentParentNewUploadContractAttachments.next(this.document.newUploadContractAttachments);
    this.createContractMohaService.document.next(this.document);
    if (this.current == 0) {
      this.createContractMohaService.isOnAutoNumber.next(this.isOnAutoNumber);
    }
  }

  public viewPdf(id) {
    return this.commonService.getViewPdfForDocument(id).subscribe(
      rs => {
        this.showPdf(rs);
      }
    );
  }

  public showPdf(blob: any) {
    const file = new File([blob], null, { type: 'application/pdf' });
    this.commonService.readFile(file, (pdfSrc) => {
      this.pdfSrc = pdfSrc;
    });
  }

  public getParentDocumentById() {
    this.documentService.getDocumentById(this.document.parentId).subscribe(rs => {
      this.selectedDocumentTypeParent = {
        id: rs.data.contractDTO.id,
        name: rs.data.contractDTO.name,
        code: rs.data.contractDTO.code,
        filePath: rs.data.contractDTO.filePath
      };
    });
  }

  checkShowRefresh() {
    return !this.refreshContractCode;
  }

  openDialogAdd() {
    const dialogRef = this.dialog.open(AddDocumentGroupV3Component, {
      width: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '100%' : '70%',
      maxWidth: this.mediaBreakpoint === SCREEN_SIZE.XS || this.mediaBreakpoint === SCREEN_SIZE.SM ? '90vw' : '80vw',
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((rs) => {
      // this.subscribeValue();
      this.getServiceTypeWhenAddDocument(rs);
    });
  }
// merge 21511
  convertTitleResource() {
    const isBuyContract1Mb = this.createContractMohaService.isBuyContract1Mb.getValue();
    const isBuyContract10Mb = this.createContractMohaService.isBuyContract10Mb.getValue();
    const configSizeApprove = this.createContractMohaService.configSizeApprove.getValue();
    const configPageSign = this.createContractMohaService.configPageSign.getValue();
    const configNumberPosition = this.createContractMohaService.configNumberPosition.getValue();
    let signPositions = [];
    let signPositionsFile = []
    if (this.valueSelect === 0) {
      signPositions = this.createContractMohaService.signatureData.getValue();
      signPositionsFile = this.createContractMohaService.signPositions.getValue();
    } else {
      signPositions = this.createContractMohaService.signPositions.getValue();
    }
    const recordPerformSigns = this.createContractMohaService.recordsUserPerformSign.getValue();
    const recordsPartySign = this.createContractMohaService.recordsPartySign.getValue();
    const fileUploadArray:any = this.createContractMohaService.fileUploadArray.getValue();
    const infoFile = this.createContractMohaService.infoFile.getValue();
    if (isBuyContract1Mb && !isBuyContract10Mb) {
      return this.message.getMessage('title.contract_document_1MB');
    } else if (!isBuyContract1Mb && isBuyContract10Mb) {
      return this.message.getMessage('title.contract_document_10MB');
    } else {
      let uploadSize = 0;
      let isMorePosition: boolean = false;
      let isMoreApproveCusAndPosition: boolean = false;
      let isMoreNumberPage: boolean = false;
      const dataUserApproves = recordPerformSigns.filter(user => user.role == '2');
      const userEntSign = recordPerformSigns.filter(user => user.role == '1');
      if (this.valueSelect === 0) {
        if (signPositions) {
          let numberPositionCheck = 0;
          const dataSignPostions = signPositions.filter(position => position.customerId || position.userId);
          const dataSignPostionsFile = signPositionsFile.filter(position => position.customerId || position.userId);

          // Kiem tra so luong nguoi phe duyet + chan ky cua chu the KHACH HANG
          for (let a = 0; a < recordsPartySign.length; a++) {
            if (!recordsPartySign[a].isCreatedSide) {
              if (recordsPartySign[a].customerApproves) {
                if (recordsPartySign[a].customerApproves.length > configSizeApprove) {
                  isMoreApproveCusAndPosition = true;
                  break;
                } else {
                  for (let b = 0; b < recordsPartySign[a].customerApproves.length; b++) {
                    const positionOfCustomerSign = dataSignPostions.filter(positon => positon.userId === recordsPartySign[a].customerId)
                    const positionOfEnterpriseSign = dataSignPostionsFile.filter(positon => positon.userId === recordsPartySign[a].customerId);
                    const positionOfCustomer = dataSignPostions.filter(positon => positon.userId === recordsPartySign[a].customerApproves[b].userId);
                    if (positionOfCustomer.length + positionOfEnterpriseSign.length + positionOfCustomerSign.length > configNumberPosition) {
                      isMoreApproveCusAndPosition = true;
                      break;
                    }
                  }
                }
              }
            }
          }

          // Kiem tra so luong chan ky cua chu the Ben Lap
          for (let i = 0; i < dataSignPostions.length; i++) {
            if (dataSignPostions[i].signature.object == "ENTERPRISE" || dataSignPostions[i].signature.object == "ENTERPRISEAPPROVER" ) {
              numberPositionCheck = numberPositionCheck + dataSignPostions[i].signature.positions.length + dataSignPostionsFile.filter(positon => userEntSign[i] && ( positon.enterpriseId === userEntSign[i].enterpriseId ||  positon.enterpriseId === userEntSign[i].enterpriseSignId)).length;
              if (numberPositionCheck > configNumberPosition) {
                isMorePosition = true;
                break;
              }
            }
          }
          // for (let i = 0; i < dataSignPostions.length; i++) {
          //     if (dataSignPostions[i].signature.object === "CUSTOMER") {
          //       if (dataSignPostions[i].signature.positions.length > configNumberPosition) {
          //         isMorePosition = true;
          //         break;
          //       }
          //     } else {
          //       numberPositionCheck = numberPositionCheck + dataSignPostions[i].signature.positions.length;
          //       if (numberPositionCheck > configNumberPosition) {
          //         isMorePosition = true;
          //         break;
          //       }
          //     }
          // }

        }
        for (let index = 0; index < fileUploadArray.length; index++) {
          const fileInfo = infoFile && infoFile.find(file => file.id === fileUploadArray[index].id) ;
          if ((fileInfo && fileInfo.numberPage > configPageSign) || (this.createContractMohaService.infoFileTemplate.getValue() && this.createContractMohaService.infoFileTemplate.getValue().numberPage > configPageSign)) {
            isMoreNumberPage = true;
            break;
          }
        }
        for (let index = 0; index < fileUploadArray.length; index++) {
          uploadSize = uploadSize + fileUploadArray[index].size
        }

      } else {
        let listFileIds = fileUploadArray.map(file => file.id);
        const filteredList = signPositions.filter(item => listFileIds.includes(item.fileId));

        //Kiem tra so luong chan ky cua chu the Ben Lap
        for (let i = 0; i < userEntSign.length; i++) {
          const positionOfEnterprises = filteredList.filter(positon => positon.enterpriseId === userEntSign[i].enterpriseId);
          if (positionOfEnterprises.length > configNumberPosition) {
            isMorePosition = true;
            break;
          }
        }
        // for (let j = 0; j < recordsPartySign.length; j++) {
        //   if (recordsPartySign[j].customerId) {
        //     const positionOfEnterprises = filteredList.filter(positon => positon.customerId === recordsPartySign[j].customerId);
        //     if (positionOfEnterprises.length > configNumberPosition) {
        //       isMorePosition = true;
        //       break;
        //     }
        //   }
        // }

        // Kiem tra so luong nguoi phe duyet + chan ky cua chu the KHACH HANG
        for (let a = 0; a < recordsPartySign.length; a++) {
          if (!recordsPartySign[a].isCreatedSide) {
            if (recordsPartySign[a].customerApproves) {
              if (recordsPartySign[a].customerApproves.length > configSizeApprove) {
                isMoreApproveCusAndPosition = true;
                break;
              } else {
                for (let b = 0; b < recordsPartySign[a].customerApproves.length; b++) {
                  const positionOfCustomerSign = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerId);
                  const positionOfCustomer = filteredList.filter(positon => positon.userId === recordsPartySign[a].customerApproves[b].userId);
                  if (positionOfCustomer.length + positionOfCustomerSign.length > configNumberPosition) {
                    isMoreApproveCusAndPosition = true;
                    break;
                  }
                }
              }
            }
          }
        }

        for (let index = 0; index < fileUploadArray.length; index++) {
          const fileInfo = infoFile && infoFile.find(file => file.id === fileUploadArray[index].id);
          if (fileInfo && fileInfo.numberPage > configPageSign) {
            isMoreNumberPage = true;
            break;
          }
        }
        for (let index = 0; index < fileUploadArray.length; index++) {
          uploadSize = uploadSize + fileUploadArray[index].size
        }
      }

      if (dataUserApproves.length <= configSizeApprove && !isMorePosition && !isMoreNumberPage && uploadSize <= this.size1MB && !isMoreApproveCusAndPosition) {
        return this.message.getMessage('title.contract_document_1MB');
      } else {
        return this.message.getMessage('title.contract_document_10MB');
      }
    }
  }
  // merge 21511

  filteredPartyOptions: any = []
  timeOutQueryServer: any;
  inputPartyValue: string = ''
  nzCheckLoadingParty2 = false
  RECORD_SHARE_PARTNER = []
  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty2 = true;
          this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
            .then(result => {
              // console.log('record party sign result', result);

              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if (!item.isCreatedSide) {
                     if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {        // Nếu chưa được chọn thì cũng mới hiển thị cho chọn
                      // Chống lặp bản ghi trong danh sách suggest
                      const existedList = this.filteredPartyOptions.filter((e) => {
                        return e.enterpriseId === item.enterpriseId;
                      });
                      // if (existedList.length === 0) {
                        this.filteredPartyOptions.push(item);
                      // }
                    }
                  } 
                }
              }
              // this.filteredPartyOptions = result;
            }).finally(() => {
              this.nzCheckLoadingParty2 = false;
            });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }
  autocompletePartySelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_SHARE_PARTNER = [
          ...this.RECORD_SHARE_PARTNER,
          {
            enterpriseId: model.enterpriseId,
            customerId: model.customerId,
            email: model.email,
            name: model.name,
            phone: model.phone,
            permission: 'FILE'
          }
        ];

        

        this.setFormChanging(true);
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
        this.createContractMohaService.recordsSharePartner.next(this.RECORD_SHARE_PARTNER);

      } else {
        this.toastr.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
      }
    }
  }
  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_SHARE_PARTNER.filter((e) => {
      return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId;
    });

    return (existedList.length > 0);
  }
  onClickDeleteElementRecordParty(enterpriseId: any, customerId:any): void {
    if (enterpriseId && enterpriseId.length > 0) {
      this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.enterpriseId !== enterpriseId);
    } else {
      this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.customerId !== customerId);
    }
    this.createContractMohaService.recordsSharePartner.next(this.RECORD_SHARE_PARTNER);
  }

  contractTerminations: any[] = []
  goToContractLiquidated(id){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/home-enterprise/view-document-moha/' + id],  {queryParams: {goFrom: 'hdld', isOnlyView: true}})
    );
    window.open(url, '_blank')
  }

  changeServiceType(){
    console.log(this.document.serviceType);
  }

  getErrorDateMessageV2(pickerInput: string, isExpired: boolean = false, nameField: string): string {
    if (!pickerInput || pickerInput === '') {
      return null;
    }

    if(nameField == 'effectiveDate' && this.document.effectiveDate && this.document.expiredDate &&
      new Date(this.document.effectiveDate) > new Date(this.document.expiredDate)
    ){
      return this.message.getMessage('form.effective_date') + ' ' + this.message.getMessage('validation.from_date_smaller_than_or_equal_to_date') + ' ' + this.message.getMessage('form.expired_date')
    }
    if(nameField == 'expiredDate' && this.document.effectiveDate && this.document.expiredDate &&
    new Date(this.document.effectiveDate) > new Date(this.document.expiredDate)
    ){
      return this.message.getMessage('form.expired_date') + ' ' + this.message.getMessage('validation.to_date_larger_than_or_equal_from_date') + ' ' + this.message.getMessage('form.effective_date')
    }

    return this.message.getMessage(isExpired ? 'validation.date_format_doc_effective_date' : 'validation.date_format_doc_expired_date');
  }
   // Danh sách tiêu chí HDLĐ
   getPropertiesForUpdate() {
    this.contractService.getPropertiesForUpdate().subscribe(
      response => {
        console.log('propertiesFor:', response.data);
        this.adjustedContents = response.data.map(content => {
          return {
            ...content,
            title: this.createContractMohaService.convertTitleContent(content.type)
          }
        })
      }
    );
  }

  viewDetailContract(id: string, type?: any) {
      if (type) {
        this.toNavigate('/home-enterprise/view-document-moha/' + id, {goFrom: 'hdld', typeCopy: type });
      } else {
        this.toNavigate('/home-enterprise/view-document-moha/' + id, {goFrom: 'hdld'} );
      }
  }

  toNavigate(route, params = {}) {
    let queryParams: any = {
      ...params,
    };
    this.router.navigate([route], {queryParams});
  }
}
